export default __webpack_public_path__ + "static/media/backet.cf53cdf8.svg";